import * as XLSX from 'xlsx'
import { Campaign } from '../types/campaign'

const sanitizeFileName = (name: string) => name.replace(/[^a-z0-9_\-\.]/gi, '_')

const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
}

export const exportCampaignToXlsx = (campaign: any) => {
  const workbook = XLSX.utils.book_new()
  const summary = {
    'Nome': campaign.name,
    'Data de Criação': formatDate(campaign.createdAt),
    'Status': campaign.status == 'COMPLETED' ? 'Finalizada' : campaign.status == 'PROCESSING' ? 'Processando' : 'Falhou',
    'Unidade de Negócio': campaign.data.bu,
    'Região': campaign.data.regiao,
    'Investimento': campaign.data.investimento,
    'Classe da Campanha': campaign.data.name,
    'Quantidade de EAN': campaign.data.quantidade_produtos,
    'Desconto Médio': campaign.data.desconto_medio,
    'Duração': campaign.data.duracao_semanas
  }
  const summarySheet = XLSX.utils.json_to_sheet([summary])
  XLSX.utils.book_append_sheet(workbook, summarySheet, 'Informações')
  if (campaign.results && Array.isArray(campaign.results)) {
    const results = campaign.results.map((i:any) => {
        return {
            'Métrica': i.metric,
            'Projeção': i.projection,
            'Margem de Erro': i.marginOfError,
            'Intervalo de Confiança': i.confidenceInterval,
        }
    })
    const resultSheet = XLSX.utils.json_to_sheet(results)
    XLSX.utils.book_append_sheet(workbook, resultSheet, 'Resultados')
  }
  const fileName = sanitizeFileName(`${campaign.name || campaign.run_id}.xlsx`)
  XLSX.writeFile(workbook, fileName)
}

export default exportCampaignToXlsx